module.exports = __webpack_public_path__ + "static/measured-5117adc09e12a2ef3a59c2aec2d61af1.mp4";